/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface RtsDocumentExtractionGet$Params {
  submissionId: string;
  documentId: string;
}

export function rtsDocumentExtractionGet(
  http: HttpClient,
  rootUrl: string,
  params: RtsDocumentExtractionGet$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, rtsDocumentExtractionGet.PATH, 'get');
  rb.path('submissionId', params.submissionId, {});
  rb.path('documentId', params.documentId, {});
  return http
    .request(rb.build({ responseType: 'json', accept: 'application/json', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => r as StrictHttpResponse<any>)
    );
}

rtsDocumentExtractionGet.PATH = '/Rts/document-extraction/{submissionId}/{documentId}';
